import { TextManager } from "./TextManager";
import { AlertDescription } from "./commonComponentEnums";
import { TextComponentConfig } from "./textInterfaces";

export const getPhoneNumberTextConfig = (): TextComponentConfig => {
  const { getText } = TextManager;
  const phonenumber = getText(AlertDescription.PHONENUMBER_STOREBRAND);
  return {
    variables: {
      phoneNumber: {
        text: phonenumber,
        url: `tel:+47${phonenumber.replace(/\s/g, "")}`,
        __type: "hyperlink",
      },
    },
  };
};
